import React from "react";
import founderImage from "../assets/guru.png";
import akhila from "../assets/akhila.jpg";
import imran from "../assets/imran.jpg";
import { Link } from "react-router-dom";

function AboutUs() {
  const leaders = [
    {
      name: "Gurusankar Chennuru",
      title: "Developer",
      image: founderImage,
      description:
        "Visionary technologist bridging talent and opportunity. Expert in strategy, operations, and product innovation. Drives value for job seekers and employers. Focused on impactful, user-centric solutions.",
      linkedin: "https://www.linkedin.com/in/gurusankar-chennuru/",
    },
    // {
    //   name: "Akhila V",
    //   title: "Developer",
    //   image: akhila,
    //   description:
    //     "Expert in business strategy and operations, ensuring the platform delivers value to both job seekers and employers.",
    //   linkedin:
    //     "https://www.linkedin.com/in/akhila---v?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    // },
    // {
    //   name: "Shaik Imran",
    //   title: "Manager",
    //   image: imran,
    //   description:
    //     "Focused on user experience and product innovation, ensuring our platform is intuitive and impactful for all users.",
    //   linkedin: "",
    // },
  ];

  return (
    <div className="bg-gradient-to-br from-gray-50 to-blue-50 min-h-screen relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute -top-20 -left-20 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-[ping_8s_ease-in-out_infinite]"></div>
      <div className="absolute top-40 -right-20 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-[ping_8s_ease-in-out_infinite] delay-1000"></div>
      <div className="absolute -bottom-20 left-40 w-72 h-72 bg-pink-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-[ping_8s_ease-in-out_infinite] delay-2000"></div>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 text-white text-center py-20 md:py-24">
        <div className="absolute inset-0 opacity-20"></div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 animate-fade-in px-4">
          About Us
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto mb-8 animate-fade-in px-4">
          We are revolutionizing the job search experience by connecting
          talented individuals with their dream opportunities through our
          innovative platform.
        </p>
      </section>

      {/* Founder Section */}
      <section className="py-16 md:py-20 relative">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Meet Our Leaders
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 justify-center">
            {leaders.map((leader, index) => (
              <div
                key={index}
                className="relative bg-white/90 backdrop-blur-xl p-4 md:p-6 rounded-[2rem] shadow-xl hover:shadow-2xl transition-all duration-500 border border-gray-100 flex flex-col items-center"
              >
                {leader.linkedin && (
                  <a
                    href={leader.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute top-3 right-3 text-blue-600 hover:text-blue-800 transition-colors"
                    title="LinkedIn Profile"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                    </svg>
                  </a>
                )}

                <div className="relative group mb-4">
                  <div className="absolute -inset-3 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600 rounded-full blur-lg opacity-70 group-hover:opacity-100 transition duration-500 animate-[spin_8s_linear_infinite]"></div>
                  <div className="relative rounded-full bg-white p-1">
                    <div className="w-32 h-32 rounded-full overflow-hidden shadow-2xl transition-all duration-500 group-hover:scale-[1.02]">
                      <img
                        src={leader.image}
                        alt={leader.name}
                        className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                      />
                    </div>
                  </div>
                </div>

                <div className="text-center space-y-2 max-w-xs flex flex-col flex-grow justify-between min-h-[200px]">
                  <h3 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    {leader.name}
                  </h3>
                  <span className="text-blue-600 font-medium text-base">
                    {leader.title}
                  </span>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {leader.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Our Mission Section */}
      <section className="py-16 md:py-20 px-4 relative">
        <div className="max-w-4xl mx-auto text-center bg-white/80 backdrop-blur-lg rounded-[2rem] p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-6">
            Our Mission
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed">
            Our mission is to transform the job search landscape by providing a
            seamless, intuitive platform that empowers both job seekers and
            employers. We're committed to making the hiring process more
            efficient and accessible for everyone.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 md:py-20 text-center relative">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-white/80 backdrop-blur-lg rounded-[2rem] p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-6">
              Get in Touch
            </h2>
            <p className="text-base md:text-lg text-gray-700 mb-8">
              Have questions or want to collaborate? We'd love to hear from you!
            </p>
            <Link
              to="/contact-us"
              className="no-underline px-10 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-2xl hover:from-blue-700 hover:to-purple-700 transition-all duration-300 hover:scale-105 hover:shadow-lg text-lg"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
